import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Subwarehouse from "../../../containers/modules/master/subwarehouse";

export default function SubWarehouseRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="sub-warehouse"
      // action={() => onRouteChanged()}
      index
      element={
        <AccessControl
          name={"Sub Warehouse List"}
          auth={authUser}
          component={() => <Subwarehouse authUser={authUser} />}
        />
      }
    />
  );
}
